const DURATIONS = {
    FULL: '7d3ae0cd-09e1-46cc-9f72-b27fcfee9409'
}

export default DURATIONS